<template>
  <div class="index">
    <div class="statistics">
      <div class="a1">
        <div class="top">
          <div class="title">
            <span class="title-left">{{$t('append_field.terminal_status')}}</span>
            <van-button color="#006EFF" size="mini" @click="reload">{{$t('append_field.refresh')}}</van-button>
          </div>
        </div>
        <div class="a1-bottom">
          <div id="a"></div>
        </div>
      </div>
      <!--      <div style="height: 40px"></div>-->
      <div class="a1">
        <div class="top">
          <div class="title">
            <span class="title-left">{{$t('append_field.memory_status')}}</span>
            <van-button color="#006EFF" size="mini" @click="reload">{{$t('append_field.refresh')}}</van-button>
          </div>
        </div>
        <div class="a1-bottom">
          <div id="b"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ECharts from 'echarts'
import qs from 'qs'
// eslint-disable-next-line no-unused-vars
import wx from 'weixin-js-sdk'

export default {
  name: 'Index',
  data() {
    return {
      charts: '',
    }
  },
  mounted() {
    document.title = this.$t('append_field.home')
    /*this.$ajax('/etv/getWeixinAccessToken.json').then(res => {
      if (res.data.code === 0) {
        wx.config({
          debug: false,//是否开启调试
           appid: 'wxf4ecc1546a053d74',
          // appid: 'wx7c28fd1ca82ad829',
          // appid: 'wxa12dcf325e893ef5',
          timestamp: res.data.data.timestamp,//时间搓，单位秒
          nonceStr: res.data.data.nonceStr,//随机字符串
          signature: res.data.data.signature,//签名md5
          jsApiList: ['scanQRCode'],
        })
      } else {
        Toast(res.data.msg)
      }
    })*/
    this.getDataa(localStorage.getItem('userId'))

  },
  methods: {
    getAECharts(id, data) {
      let charts = ECharts.init(document.getElementById(id))
      charts.setOption({
        color: ['#006EFF', '#2FC25B', '#999966', '#F04864', '#CC3399', '#FACC14', '#CC6600'],
        legend: {
          x: 'center',
          y: 'bottom',
          show: true,
          margin: 4,
          itemWidth: 8,
          itemHeight: 8,
        },
        series: [
          {
            name: this.$t('append_field.source_of_visit'),
            type: 'pie',
            radius: ['30%', '60%'],
            center: ['50%', '40%'],
            minAngle: 4,
            startAngle: 380,
            legendHoverLink: true,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'outer',
                  formatter: '{d}%',
                },
                labelLine: {
                  show: true,
                  length: 10,
                },
              },
              emphasis: {
                label: {
                  show: true,
                  position: 'center',
                  textStyle: {
                    fontSize: '15',
                    fontWeight: 'normal',
                  },
                },
              },
            },
            data: data,
          },
        ],
      })

    },
    getDataa(id) {
      this.$ajax.post('/etv/selectIndexStats.json').then(res => {
        if (res.data.code === 0) {
          let data = [{
            'name': this.$t('append_field.online'),
            'value': res.data.data.onLineNum,
          }, {
            'name': this.$t('append_field.offline'),
            'value': res.data.data.offLineNum,
          }]
          this.getAECharts('a', data)
        }
      })
      this.$ajax.post('/etv/selectPersonerInfoById.json', qs.stringify({
        id,
      })).then(res => {
        if (res.data.code === 0) {
          let data = []
          res.data.data.everyTypeRam && res.data.data.everyTypeRam.map(res => {
            data.push({
              name: res.name,
              value: res.y,
            })
          })
          this.getAECharts('b', data)
        }
      })
    },
    reload() {
      this.getAECharts('a', '')
      this.getAECharts('b', '')
      this.getDataa(localStorage.getItem('userId'))
      wx.miniProgram.reLaunch({
        url: '/pages/index/index'
      })
    },

    inputDialogClose() {
      this.showPicker = false
      this.programShow = false
      this.programgroupName = ''
    },

  },
}
</script>

<style scoped lang="scss">
@import "../../public/static/css/app";

.index {
  /*position: fixed;*/
  height: 100%;
  overflow-y: auto;
  /*top: 0;*/
  /*left: 0;*/
  /*right: 0;*/
  /*bottom: 10px;*/

  .occupied {
    height: 30px;
    background: $uni-color-primary;
    top: 0;
    left: 0;
    width: 100%;
    position: fixed;
  }

  .home-top {
    height: 40px;
    width: 100%;
    padding: 0 30px;
    box-sizing: border-box;
    z-index: 999;
    position: relative;

    .harfBackground {
      position: absolute;
      left: 0;
      top: -20px;
      height: 40px;
      width: 100%;
      background: #006EFF;
      z-index: -1;
    }

    .home-top-content {
      width: 100%;
      height: 100%;
      background: $uni-text-color-inverse;
      border-radius: 15px;
      box-shadow: 0 0 5px $uni-border-bottom-color;
      padding: 0 25px;
      box-sizing: border-box;
      display: flex;
      z-index: 6;
      justify-content: space-between;
      align-items: center;

      .scan {
        display: flex;
        align-items: center;
        height: 20px;
        color: $uni-text-color;

        .etv-scan_icon {
          font-size: 16px;
          margin-right: 10px;
          font-weight: 600;
        }
      }
    }
  }

  .statistics {
    /*padding-top: 65px;*/
    height: calc(100% - 60px);
    overflow-y: auto;

    .a1 {
      margin: 10px 0;
      background: #fff;
      height: 46%;

      .top {
        border-bottom: 1px solid #838383;

        .title {
          padding: 0 36px;
          display: flex;
          height: 40px;
          align-items: center;
          justify-content: space-between;

          .title-left {
            display: inline-block;
            border-left: 3px solid #ffa000;
            padding-left: 5px;
          }
        }
      }

      .a1-bottom {
        height: 80%;
      }

      #a {
        height: 100%;
        width: 100%;
      }

      #b {
        height: 100%;
        width: 100%;
      }
    }
  }

  .van-content {
    display: flex;

    .van-label {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 75px;
      margin-right: 10px;
    }

    .van-input {
      width: calc(100% - 30px);
      height: 40px;
      border: 1px solid #DDDFE6;
      border-radius: 4px;
      padding-left: 10px;
    }
  }

}
</style>
